import { render } from "./ServiceCard.vue?vue&type=template&id=534e079d&scoped=true&ts=true"
import script from "./ServiceCard.vue?vue&type=script&lang=ts"
export * from "./ServiceCard.vue?vue&type=script&lang=ts"

import "./ServiceCard.vue?vue&type=style&index=0&id=534e079d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534e079d"]])

export default __exports__